import { Component } from '@angular/core';

import {
  CamStepFormComponent,
  CamStepFormService,
  EditFieldComponent,
  FormComponent,
  ICamStepFormStep,
  InputsComponent,
} from '@camelot/form-basic';
import { InputBase, InputCheckBox, CamAbstractInput, InputPanel, InputTextBox } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

interface StepFormData {
  name?: string;
}

@Component({
    imports: [CamStepFormComponent, EditFieldComponent, FormComponent, InputsComponent, TestIdDirective],
    template: `
    <cam-form camTestId="cam-form" [inputs]="this.formInputs" />
    <cam-inputs camTestId="cam-inputs" [input]="this.standaloneInput" [standalone]="true" />
    <cam-edit-field camTestId="cam-edit-field" [getInput]="this.getInput" />
    <cam-step-form camTestId="cam-step-form" [steps]="this.steps" [service]="this.stepService" />
  `
})
export class FormBasicCase {
  public formInputs: CamAbstractInput[] = [
    new InputTextBox({ key: 'name', label: 'Name' }),
    new InputCheckBox({ key: 'agree', label: 'Agree' }),
    new InputPanel({
      children: [new InputTextBox({ key: 'street', label: 'Street' })],
      key: 'panel',
    }),
  ];
  public standaloneInput = new InputTextBox({ key: 'standalone', label: 'Standalone' });
  public stepService = new CamStepFormService<StepFormData>();
  public steps: ICamStepFormStep<StepFormData>[] = [
    { form: () => [new InputTextBox({ key: 'name', label: 'Name' })], title: 'Step one' },
    { form: () => [new InputTextBox({ key: 'email', label: 'Email' })], title: 'Step two' },
  ];

  public getInput = (): InputBase<any> => new InputTextBox({ key: 'edit', label: 'Edit me' });
}
